export const AddToCalendarPlacement = {
    ALERT: 'ALERT',
    EVENT_CARD: 'EVENT_CARD'
};

export const AuthenticatorType = {
    ADOBE: 'adobe',
    IP: 'ip'
};

export const AdobePass = {
    Env: {
        PROD: 'production',
        STAGING: 'staging'
    },
    METADATA: {
        TTL_AUTHN: 'TTL_AUTHN',
        TTL_AUTHZ: 'TTL_AUTHZ',
        USERID: 'userID',
        UPSTREAM_USERID: 'upstreamUserID',
        PACKAGE_ID: 'packageId',
        PACKAGE_TIER: 'tier'
    }
};

export const Api = {
    Page: {
        EVENT_QUERY_KEYS: [
            'airingId',
            'eventId',
            'id',
            'network',
            'channel',
            'gameId',
            'country'
        ],
        PCC_NETWORK_NAMES: [
            'espn',
            'espn2',
            'espn3',
            'espnu',
            'longhorn',
            'espnews',
            'espndeportes',
            'sec',
            'secplus',
            'accextra',
            'acc'
        ]
    },
    Env: {
        DEV: 'dev',
        QA: 'qa',
        STAGING: 'staging',
        PROD: 'prod'
    }
};

export const AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

export const BlackoutTypes = {
    DMA: 'dma',
    DEVICE: 'device'
};

export const BucketLayout = {
    COLLECTION: 'COLLECTION',
    DEFAULT: 'DEFAULT',
    DEFAULT_UNLIMITED: 'DEFAULT_UNLIMITED',
    HERO: 'HERO',
    'feature-left': 'feature-left',
    'feature-right': 'feature-right',
    TAPESTRY_LEFT: 'TAPESTRY_LEFT', // will be deprecated
    TAPESTRY_RIGHT: 'TAPESTRY_RIGHT', // will be deprecated
    SixteenNineTapestryLeft: 'TAPESTRY_LEFT', // will be deprecated
    SixteenNineTapestryRight: 'TAPESTRY_RIGHT', // will be deprecated
    SCHEDULE_MODULE: 'SCHEDULE_MODULE',
    DEFAULT_EXPANDABLE: 'DEFAULT_EXPANDABLE',
    LARGE_EXPANDABLE: 'LARGE_EXPANDABLE',
    SixteenNine: 'SixteenNine',
    FiveTwo: 'FiveTwo',
    TwoThree: 'TwoThree',
    FourThree: 'FourThree',
    Carousel: 'carousel'
};

export const LayoutThresholds = {
    DEFAULT_UNLIMITED: undefined,
    'feature-left': 5,
    'feature-right': 5,
    TAPESTRY_LEFT: 5,
    TAPESTRY_RIGHT: 5,
    COLLECTION: undefined
};

export const LayoutVariant = {
    COLLECTION: 'collection',
    DTC: 'dtc'
};

export const Device = {
    DESKTOP: 'desktop',
    HANDSET: 'handset',
    TABLET: 'tablet'
};

export const DeviceType = Object.keys(Device).reduce((acc, key) => {
    acc[Device[key]] = key;
    return acc;
}, {});

export const BucketStatus = {
    WEB_LIVE: 'WEB_LIVE',
    WEB_UPCOMING: 'WEB_UPCOMING'
};

export const OneIdEnv = {
    STAGING: 'staging',
    PROD: 'prod'
};

export const PageType = {
    HOME: 'HOME',
    COLLECTION: 'COLLECTION',
    FEATURES: 'FEATURES',
    SEARCH: 'SEARCH',
    ORIGINALS: 'ORIGINALS',
    SID: 'SID',
    CATALOG: 'CATALOG'
};

export const PlayerError = {
    AUTHORIZATION: 'AUTHORIZATION',
    DEFAULT: 'DEFAULT',
    UNSUPPORTED: 'UNSUPPORTED'
};

export const PlayerEvents = {
    ESPN_PLAYING: 'espn.playing',
    ESPN_PLAY: 'espn.play',
    ESPN_PAUSE: 'espn.pause',
    ESPN_AD_POD_STARTED: 'espn.ads-pod-started',
    ESPN_AD_POD_ENDED: 'espn.ads-pod-ended',
    ESPN_AD_STARTED: 'espn.ads-ad-started',
    ESPN_AD_ENDED: 'espn.ads-ad-ended',
    ESPN_CONTENT_ENDED: 'espn.contentended',
    ESPN_CONTENT_LOADED: 'espn.contentloaded',
    ESPN_PROGRAM_CHANGE: 'espn.programchange',
    ESPN_AUTOPLAY_TOGGLED: 'espn.autoplaytoggled',
    ESPN_SOCIAL_OPENED: 'socialopened',
    ESPN_SOCIAL_CLOSED: 'socialclosed',
    ESPN_CAPTION_OPENED: 'captionopened',
    ESPN_CAPTION_CLOSED: 'captionclosed',
    ESPN_ERROR: 'espn.error'
};

export const Route = {
    HOME: '',
    FEATURES: 'features',
    SCHEDULE: 'schedule',
    PLAYER: 'player'
};

export const Storage = {
    Analytics: {
        IS_AUTHENTICATING: 'IS_AUTHENTICATING'
    }
};

export const ModalType = {
    POPUP: 'POPUP',
    FLASH: 'FLASH',
    BLACKOUT_MAP: 'BLACKOUT_MAP',
    IFRAME_AUTH: 'IFRAME_AUTH',
    PAYWALL: 'PAYWALL',
    BROADCAST_PICKER: 'BROADCAST_PICKER'
};

export const ContentType = {
    LISTING: 'listing',
    VOD: 'vod',
    PRODUCT: 'product',
    SHOW: 'show',
    FILM: 'film',
    ONDEMAND: 'onDemand',
    PROGRAM: 'program',
    // legacy type for `v1` Page API used for legacy 5.x app
    EVENT: 'event',
    VIDEO: 'video',
    TERM: 'term',
    COMPILATION: 'compilation'
};

export const URLPath = {
    [ContentType.PRODUCT]: 'product',
    [ContentType.SHOW]: 'series',
    [ContentType.FILM]: 'film',
    [ContentType.PROGRAM]: 'program',
    [ContentType.TERM]: 'search',
    [ContentType.COMPILATION]: 'compilation'
};

// should we use this for `type` field in listings API?
export const ContentStatus = {
    LIVE: 'live',
    UPCOMING: 'upcoming',
    REPLAY: 'replay',
    OVER: 'over'
};

export const SourceType = {
    LINEAR: 'linear',
    ONLINE: 'online'
};

export const AuthTypes = {
    MVPD: 'mvpd',
    ISP: 'isp',
    BAM: 'direct',
    OPEN: 'open'
};

export const AuthStates = {
    MVPD: 'mvpd_login',
    ISP: 'isp',
    MVPD_PREVIOUS: 'mvpd_previous'
};

export const Entitlements = {
    ESPN_PLUS: 'ESPN_PLUS',
    ESPN_PLUS_MLB: 'ESPN_PLUS_MLB',
    ESPN_PLUS_NHL: 'ESPN_PLUS_NHL',
    ESPN_EXEC: 'ESPN_EXEC',
    ESPN_PLUS_UFC_PPV: 'ESPN_PLUS_UFC_PPV',
    ESPN_TDA: 'fallback_subscription_directbilling_tda'
};

export const ComScoreC3 = {
    [Entitlements.ESPN_PLUS]: 'ESPNPlus',
    [Entitlements.ESPN_PLUS_NHL]: 'NHLTV',
    [Entitlements.ESPN_PLUS_MLB]: 'MLBTV'
};

// list of URL query flags we use
export const Flags = {
    APP_NAME: 'appName',    // The app can be the default "webapp", or "espnapp"
    ADOBEPASS_ENV: 'passenv',   // used to point Adobe Pass Access Enabler to different environment
    API_ENV: 'apienv', // points the site at whatever PageApi environment,
    CONFIG_ENV: 'configenv', // use config file for the specified env (`qa` or `prod`)
    COUNTRY: 'country', // allows to override X-Country header to determine country
    LANG: 'lang', // allows to override Accept-Language header
    DEBUG_AD: 'debug_ad', // used for printing out gpt ads info
    DEVICE: 'device', // overrides the devices detected from X-Device header
    PACKAGE_ID: 'packageId', // allows testing passing this packageId into pageApi
    PLAYER_TECH: 'playertech', // overrides the player tech (for forcing brightcove in webviews).
    ROADBLOCK: 'roadblock', // set to false to disable the authenticated content roadblock
    FROM_ROADBLOCK: 'rb', // set this to indicate that we were linked from the roadblock page (prevents cyclic redirection)
    ROADBLOCK_NO_UNIVERSAL_LINK: 'rb_noul', // do not use Universal Link logic
    HIDENAV: 'hidenav', // Used by webview in apps to remove top nav bars
    CLIENT_NAV: 'clientnav', // a flag to enable client side rendering from the header navigation
    WEBVIEW: 'webview', // Used by webview in apps to render the page completely w/o page shell
    ENABLE_SEARCH: 'search', // Used to enable search box on home page
    BYPASS_TOKEN: 'bypass_token', // Used to bypass AdobePass auth step
    PACKAGE_FILTER: 'pkg_filter', // Used to filter contents by packageId for international
    SSR: 'ssr', // Used to indicate if the server side rendering should be used or not,
    REGION: 'region', // ESPN App passes this as the edition to webviews.  We use this instead of headers if present
    PLAYER_ID: 'playerId', // A Brightcove playerId to override the default one
    ONEID_ENV: 'oneidenv', // Staging or Production OneID environment
    PARTNER: 'partner', // Used for partner syndicated player
    CATEGORY_ID: 'categoryId', // Syndicated player (i.e. US Open) to filter schedule correctly by (categoryId, id, partner)
    AUTO_DISPLAY_PROVIDER_DIALOG: 'autoDisplayDialog', // Used for syndicated player to show provider dialog immediately
    SHOW_SCHEDULE_IN_SYNDICATED_PLAYER: 'scheduleModule', // Used for showing schedule module in the syndicated player
    AUTH_RETRY: 'auth_retry', // Used when the syndicated player reload itself when the mvpd auth state failed to reflect
    XDOMAIN_BLOCKED: 'xd_blocked', // Used in the syndicated player to indicate that the browser blocks cross domain storage
    DEBUG: 'debug', // Used for the page shell to work in debug mode
    DISNEY_ENV: 'disneyid', // Used for the page shell to determine where to load `DisneyID.js`
    DISNEY_CLIENT_ID: 'disneyClientId', // Used for the page shell to override the `clientId` for OneID
    BAM_ENV: 'bamenv', // points BAM SDK to its env (`beta` or `qa`)
    MEDIA_LOCATION: 'ml', // temp param to override `media location(videoHref)`
    PAYWALL: 'paywall', // use BAM's paywall page
    PASS_ONEID_TOKEN: 'pass_token', // override bootstrap `bam.passToken` flag
    NO_SSR: 'no_ssr',
    PACKAGE_TIER: 'tier', // Package tier,
    EDITION: 'edition', // used to send edition to API calls i.e. carribean
    UNSUPPORTED_ERROR: 'unsupported_error', // Used to trigger the redirect to the /unsupported error page
    VIDEO_ADS_PROVIDER: 'videoAdsProvider', // Overrides which Ad Provider to use `google` or `freewheel` for the Player
    VIDEO_ADS_CMSID: 'videoAdsCMSID', // Overrides the GAM `cmsid` param for the Player
    VIDEO_ADS_NETWORK_CODE: 'videoAdsNetworkCode', // Overrides the `networkCode` adsConfig param for the Player
    VIDEO_ADS_AD_UNIT: 'videoAdsAdUnit', // Overrides the `adUnit` adsConfig param for the Player
    APP_DRM_SUPPORT: 'appDrmSupport', // indicates that the app (embedding the site as a webview) supports DRM
    MUTED: 'muted'
};

export const PlayerPlacement = {
    HERO: 'hero',
    PLAYER: 'player'
};

export const ESPNAppCookie = {
    AUTH: 'espnappwatchtab_auth',
    PERSONALIZATION: 'espnappwatchtab_personalization'
};

export const SyndicatedPlayerLoginOptions = {
    SELF: 0,
    NEW_WINDOW: 1,
    NEW_WINDOW_MANAGED: 2
};

export const BreakPoints = {
    MOBILE: 'mobile',
    MOBILE_LARGE: 'mobile-lg',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
    DESKTOP_LARGE: 'desktop-lg'
};

export const BucketRatio = {
    SixteenNine: '16x9',
    FourThree: '4x3',
    FiveTwo: '5x2',
    TwoThree: '2x3'
};

export const BucketRatioCols = {
    [BreakPoints.MOBILE]: {
        [BucketRatio.SixteenNine]: 1,
        [BucketRatio.FourThree]: 2,
        [BucketRatio.FiveTwo]: 1,
        [BucketRatio.TwoThree]: 2
    },
    [BreakPoints.MOBILE_LARGE]: { // 598
        [BucketRatio.SixteenNine]: 1,
        [BucketRatio.FourThree]: 4,
        [BucketRatio.FiveTwo]: 1,
        [BucketRatio.TwoThree]: 3
    },
    [BreakPoints.TABLET]: { // 768
        [BucketRatio.SixteenNine]: 3,
        [BucketRatio.FourThree]: 4,
        [BucketRatio.FiveTwo]: 2,
        [BucketRatio.TwoThree]: 4
    },
    [BreakPoints.DESKTOP]: { // 1024
        [BucketRatio.SixteenNine]: 4,
        [BucketRatio.FourThree]: 4,
        [BucketRatio.FiveTwo]: 2,
        [BucketRatio.TwoThree]: 5
    },
    [BreakPoints.DESKTOP_LARGE]: { // 1260
        [BucketRatio.SixteenNine]: 4,
        [BucketRatio.FourThree]: 4,
        [BucketRatio.FiveTwo]: 3,
        [BucketRatio.TwoThree]: 6
    }
};

export const RenderTemplateTypes = {
    BASIC: 'basic',
    PAGE_SHELL: 'pageShell'
};

export const SortOrder = {
    DESC: 'DESC',
    ASC: 'ASC'
};

export const DarkThemeLogos = {
    espn_free: 'espn_free_wht',
    accextra: 'accextra_wht'
};

export default {
    AddToCalendarPlacement,
    AdobePass,
    Api,
    AppEnvs,
    BucketLayout,
    BucketStatus,
    PageType,
    PlayerError,
    PlayerEvents,
    Route,
    Storage,
    ModalType,
    Flags,
    BucketRatio,
    BucketRatioCols
};



// WEBPACK FOOTER //
// ./app/enums.js